<template>
    <q-modal
        v-model="visible"
        @hide="onModalHide"
        ref="modal"
        :content-css="{width: '500px'}"
    >
        <div class="q-pa-lg">
            <h1>Новый проект</h1>
            <form
                autocomplete="off"
                novalidate
                @submit.prevent="createProject"
                method="post"
            >
                <q-field>
                    <q-input
                        stack-label="Название"
                        v-model="project.name"
                        :error="$v.project.name.$error"
                    />
                </q-field>
                <q-field>
                    <q-input
                        stack-label="Домен"
                        v-model="domain"
                        :error="$v.project.domains.$error"
                    />
                </q-field>
                <q-field>
                    <q-select
                        float-label="Регион"
                        v-model="project.region"
                        :options="regionOptions"
                        :error="$v.project.region.$error"
                    />
                </q-field>
                <q-field>
                    <q-select
                        float-label="Размещение"
                        v-model="project.prod_location"
                        :options="prodLocationOptions"
                        :error="$v.project.prod_location.$error"
                    />
                </q-field>
                <q-field>
                    <q-input
                        stack-label="Версия БД"
                        v-model="project.database_id"
                        :disable="disableMcpParams"
                        :loading="!areMcpParamsLoaded"
                        :error="$v.project.database_id.$error"
                    />
                </q-field>
                <q-field>
                    <q-input
                        stack-label="Пароль БД"
                        v-model="project.database_password"
                        :disable="disableMcpParams"
                        :loading="!areMcpParamsLoaded"
                        :error="$v.project.database_password.$error"
                    />
                </q-field>
                <q-field>
                    <q-input
                        stack-label="Версия бекенда"
                        v-model="project.backend_name"
                        :disable="disableMcpParams"
                        :loading="!areMcpParamsLoaded"
                        :error="$v.project.backend_name.$error"
                    />
                </q-field>
                <div class="row justify-end q-mt-md">
                    <q-btn
                        label="Создать"
                        type="submit"
                        color="primary"
                        class="q-mr-xs"
                        :loading="saving"
                    />
                    <q-btn
                        label="Отмена"
                        @click="hideModal"
                        color="primary"
                        flat
                    />
                </div>
            </form>
        </div>
    </q-modal>
</template>

<script>
import {
  QField,
  QInput,
  QSelect,
  QChipsInput,
  QBtn,
  QModal
} from 'quasar';

import {
  required,
  requiredIf,
  numeric,
} from 'vuelidate/lib/validators';

import columnsValues from '@/HTable/columnsValues'
import _ from "lodash";

export default {
  name: 'ProjectCreate',
  components: {
    QField,
    QInput,
    QSelect,
    QChipsInput,
    QBtn,
    QModal
  },
  props: {
    value: Boolean
  },
  computed: {
    visible: {
      get () {
        return this.value;
      },
      set () {
      }
    },
    regionOptions () {
      return columnsValues.regions
    },
    prodLocationOptions () {
      return columnsValues.locations
    },
    disableMcpParams () {
      return (!this.project.region || this.project.prod_location !== 'SUNRISE_MCP') || !this.areMcpParamsLoaded
    },
    selectedRegion () {
      return this.project.region
    },
    selectedProdLocation () {
      return this.project.prod_location
    },
  },
  watch: {
    domain () {
      this.project.domains = [{
        fqdn: this.domain,
        redirect_to_https: false,
        ssl: 'NONE'
      }];
    },
    selectedRegion () {
      this.updateMcpParams()
    },
    selectedProdLocation () {
      this.updateMcpParams()
    },
  },
  data () {
    return {
      project: {
        name: null,
        status: 'NEW',
        ssl: 0,
        domains: [],
        region: '',
        prod_location: '',
        database_id: '',
        database_password: '',
        backend_name: '',
      },
      domain: '',
      saving: false,
      areMcpParamsLoaded: true,
    };
  },
  validations: {
    project: {
      name: {required},
      domains: {required},
      ssl: {required, numeric},
      status: {required},
      region: {required},
      prod_location: {required},
      database_id: {required: requiredIf((project) => project.prod_location === 'SUNRISE_MCP')},
      database_password: {required: requiredIf((project) => project.prod_location === 'SUNRISE_MCP')},
      backend_name: {required: requiredIf((project) => project.prod_location === 'SUNRISE_MCP')},
    },
  },
  methods: {
    createProject () {
      this.$v.project.$touch();
      if (this.$v.project.$error) {
        this.$q.notify('Please review fields again.');
        return;
      }

      this.saving = true

      this.$http.post(`api/v1.0/projects`, this.project).then(async response => {
        if (response.status === 201) {
          await this.$router.push(`${window.location.pathname}/${this.getNewProjectId(response.headers.location)}`);
        } else {
          await this.awaitProjectCreation();
        }
      }).catch(error => {
        _.forIn(error.response.data.errors, (value) => {
          this.$q.notify({message: value[0], type: 'negative'});
        });
      }).finally(() => {
        this.saving = false
      });
    },
    async awaitProjectCreation () {
      while (true) {
        await new Promise(resolve => setTimeout(resolve, 20000));

        const response = await this.$http.get(`api/v1.0/projects/creation-status/${this.project.name}`);

        if (response.data.status === 'ERROR') {
          this.$q.notify({message: response.data.message, type: 'negative'});
          break;
        }

        if (response.data.status === 'DONE') {
          await this.$router.push(`${window.location.pathname}/${response.data.id}`);
          break;
        }
      }
    },
    getNewProjectId (location) {
      let chunks = location.split('/');

      return chunks[chunks.length - 1];
    },
    hideModal () {
      this.$refs.modal.hide();
    },
    onModalHide () {
      this.$emit('input', false);
      this.restoreInitialData()
    },
    restoreInitialData () {
      Object.assign(this.$data, this.$options.data.call(this));
    },
    updateMcpParams () {
      if (this.disableMcpParams) {
        this.project = {
          ...this.project,
          database_id: '',
          backend_name: '',
        }

        return;
      }

      const configRegion = this.selectedRegion === 'UA' ? 'UA' : 'EU'
      this.areMcpParamsLoaded = false

      this.$http.get(`api/v1.0/project_configs?region=${configRegion}`).then(response => {
        const config = response.data[0]
        const { database_id, backend_name } = config;

        this.project = {
          ...this.project,
          database_id,
          backend_name,
        }
      }).finally(() => {
        this.saving = false
        this.areMcpParamsLoaded = true
      });
    },
  }
};
</script>






// WEBPACK FOOTER //
// resources/assets/js/components/ProjectCreate/ProjectCreate.vue